/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */



/* eslint-disable no-console */
import React, { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {
  CalendarNav,
  CalendarNext,
  CalendarPrev,
  CalendarToday,
  Eventcalendar,
  localeEn,
  localeHi,
  localeEs,
  localePtPT,
  MbscCalendarDayData,
  MbscCalendarEvent,
  MbscCalendarEventData,
  MbscCellClickEvent,
  MbscEventcalendarView,
  MbscEventClickEvent,
  MbscEventCreateEvent,
  MbscEventDragEvent,
  MbscResource,
  MbscSelectedDateChangeEvent,
  Segmented,
  SegmentedGroup,
  setOptions,
} from '@mobiscroll/react';
import { ChangeEvent, FC, useCallback, useEffect, useRef, useState } from 'react';
import './Calendar.css';
import { Avatar, Box, Button, ButtonGroup, Chip, Divider, IconButton, Menu, MenuItem, Stack, styled, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import HorizontalAvatarList from '../avatarListComponent';
import { cancelAppointmentOOO, departmentsByClinic, getAppointments, getAppointmentsOOO, getUsersByClinic, updateAppointmentDate } from '../../services/apiService';
import { Appointment, CustomMbscEvent, DepartmentDetail, UserBasic } from '../../types';
import { useAlert } from '../alertProvider';
import { useLoader } from '../loaderProvider/loader';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import AppointmentTable from '../AppointmentTable/appointmentTable';
import '../../custom-mobiscroll-theme.scss';
import AppointmentModal from '../appointmentForm/appointmentForm';
import { EventcalendarBase } from '@mobiscroll/react/dist/src/core/components/eventcalendar/eventcalendar';
import { convertToLocalDateTime, formatDateToDDMMYYYY, formatDateToLocalYYYYMMDD } from '../../services/time';
import CustomModal from '../appointmentViewModal';
import { useClinic } from '../ClinicProvider';
import OutOfOfficeForm from './outOfOfficeForm';
import { getDepartmentColor, getEventBgColor, getStatusColor, isDateInPast, scheduleFilters, toTitleCase } from '../../utils/commonUtils';
import { getStatus, Status } from './Calendar.helper';
import {ReactComponent as SendBackIcon} from '../../assets/SVG/send-Back.svg';
import { useVerboseLog } from '../../utils/debug';
import { getButtonStates, isDepartmentFeatureEnabled } from '../../utils/permissionService';

// import AppointmentTable from '../AppointmentTable/appointmentTable';


setOptions({
  theme: 'ios',
  themeVariant: 'light',
  accent: 'Orange'
});

const mobiscrollLocales: { [key: string]: any } = {
  en: localeEn,
  es: localeEs,
  hi: localeHi,
  pt: localePtPT
};

const CalendarComponent: FC = () => {
  const { t: tCalendar, i18n } = useTranslation('calendar');
  const { t: tGeneral } = useTranslation('general');
  const mobiscrollLocale = mobiscrollLocales[i18n.language] || localeEn;

  const [view, setView] = useState('month');
  const [resource, setResource] = useState<MbscResource[] | undefined>();
  const [myEvents, setEvents] = useState<MbscCalendarEvent[]>([]);
  const [calView, setCalView] = useState<MbscEventcalendarView | undefined>(undefined);
  const [menuPosition, setMenuPosition] = useState<{ mouseX: number; mouseY: number } | null>(null);
  const [clickedEvent, setClickedEvent] = useState<MbscCalendarEvent | null>(null);
  const [useTimeline, setUseTimeline] = React.useState(true);
  const [tabValue, setTabValue] = useState<DepartmentDetail>();
  const [currentView, setCurrentView] = useState<'CALENDAR' | 'TABLE'>('CALENDAR');
  const [appointments, setAppointments] = useState<Appointment[] | undefined>();
  const [departmentList, setDepartmentList] = useState<DepartmentDetail[]>([]);
  const [showOutofOfficeForm, setShowOutofOfficeForm] =  useState<boolean>(false);
  const [oooEvents, setOooEvents] = useState<MbscCalendarEvent[]>([]);
  const [status, setStatus] = useState<Status[] | null>();
  const [viewDateFrom, setViewDateFrom] = useState<Date | null>();
  const [viewDateTo, setViewDateTo] = useState<Date | null>();
  const [filterAppointments, setFilterAppointments ] = useState<string | undefined>(undefined);
  const [filterAppointmentsScheduled, setFilterAppointmentsScheduled ] = useState<string | undefined>(undefined);
  const [initialLoad, setInitialLoad ] = useState<boolean>(true);

  const handlePageLoad = useCallback((args: any) => {
    if (viewDateFrom?.toISOString() !== args.firstDay.toISOString() ||
    viewDateTo?.toISOString() !== args.lastDay.toISOString()) {
      setViewDateFrom(args.firstDay);
      setViewDateTo(args.lastDay);
    }
    // console.log(viewDateFrom, viewDateTo);
  }, [viewDateFrom, viewDateTo]);
    
  const handleClosehowOutofOfficeFormModel = () => {
    setShowOutofOfficeForm(false);
    setModelStateUpdate(!modelStateUpdate);
  };
  const {addAlert} = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const { ClinicId } = useClinic();

  const [openViewModel, setOpenViewModel] = React.useState(false);
  const handleOpenViewModel = () => setOpenViewModel(true);
  
  const handleCloseViewModel = () => {
    setOpenViewModel(false);
    setViewEvent(undefined);
    setModelStateUpdate(!modelStateUpdate);
  };
  
  const [viewEvent, setViewEvent] = React.useState<MbscEventClickEvent | undefined>(undefined);

  const [openCreateModel, setOpenCreateModel] = React.useState(false);

  // const handleOpenCreateModel = () => setOpenCreateModel(true);
  /**
   * Opens the create event modal if the end date is in the future.
   *
   * @param event - The event object containing start and end dates.
   *
   * If the end date is in the past, an alert is shown, and the modal won't open.
   **/
  const handleOpenCreateModel = (event: MbscEventCreateEvent) => {
    const selectedDate = event.event.end as Date;

    if (isDateInPast(selectedDate)) {
      setCreateEvent(undefined);
      setModelStateUpdate(!modelStateUpdate);
      addAlert(tCalendar('oopsFutureDate'), 'info');
      return;
    }
    setOpenCreateModel(true);
  };


  const handleOpenCreateModelSC = (event: MbscCellClickEvent) => {
    const selectedDate = event.date as Date;

    if (isDateInPast(selectedDate)) {
      setCreateEvent(undefined);
      setModelStateUpdate(!modelStateUpdate);
      addAlert(tCalendar('oopsFutureDate'), 'info');
      return;
    }
    setOpenCreateModel(true);
  };


  const handleCloseCreateModel = () => {
    setCreateEventSC(undefined);
    setCreateEvent(undefined);
    setOpenCreateModel(false);
    setModelStateUpdate(!modelStateUpdate);
  };
  const [createEvent, setCreateEvent] = React.useState<MbscEventCreateEvent | undefined>(undefined);
  const [createEventSC, setCreateEventSC] = React.useState<MbscCellClickEvent | undefined>(undefined);
  const [users, setUsers] = React.useState<UserBasic[] | undefined>(undefined);
  const [selectedDoctor, setSelectedDoctor] = React.useState<number[]>([]);
  const [query, setQuery] = React.useState<string |  undefined>(undefined);
  const [modelStateUpdate, setModelStateUpdate] = useState(false);
  
  // Keep original English names for filtering/logic (to match API responses)
  const departmentFilters = ['Admin', 'Pathology', 'Semen Collection'];
  const docFilters = ['Consultation', 'Ultrasound', 'Surgery'];
  
  // Create a mapping function to get localized department names
  const getDepartmentDisplayName = (departmentName: string) => {
    const nameMap: { [key: string]: string } = {
      'Admin': tCalendar('admin'),
      'Pathology': tCalendar('pathology'),
      'Semen Collection': tCalendar('semenCollection'),
      'Consultation': tCalendar('consultation'),
      'Ultrasound': tCalendar('ultrasound'),
      'Surgery': tCalendar('surgery')
    };
    return nameMap[departmentName] || departmentName;
  };
  
  const [selectedDate, setSelectedDate] = useState<string | null>();

  const { canAdd, canEdit } = getButtonStates('Admin', 'Calendar', tabValue?.name ?? '');

  useEffect(() => {
    const fetchDepartments = async () => {
      if (ClinicId) {
        try {
          const response = await departmentsByClinic(ClinicId);
          setDepartmentList(response.objects);
        } catch (error: any) {
          const message = tCalendar('failedToFetchDepartments');
          addAlert(message, 'error');
          if (error?.response?.status === 403) {
            addAlert('Access denied: You do not have permission to view departments.', 'error');
          } else {            
            console.error('Error fetching departments:', error);
          }
        }
      }
    };
    fetchDepartments();
  }, [ClinicId, addAlert, tCalendar]);


  useEffect(() => {
    setSelectedDoctor([]);
  }, [tabValue]);

  useEffect(() => {
    if (departmentList && departmentList.length > 0) {
      // Try to find 'Admin' department
      const adminDept = departmentList.find((department: DepartmentDetail) => department.name === 'Admin');
      if (adminDept) {
        setTabValue(adminDept);
      } else {
        // Fallback: set first department as default
        setTabValue(departmentList[0]);
      }
    }
  }, [departmentList]);

  // Debounced fetch users for timeline view
  const debouncedFetchUsers = useMemo(() => {
    return debounce(() => {
      getUsersByClinic(ClinicId, null, 'DOCTOR').then((userRes) => setUsers(userRes.objects));
    }, 400);
  }, [ClinicId]);

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (view === 'timeline') {
      setUsers([]);
      const query = `limit=${limit}&order_by=end_datetime&role=DOCTOR`;
      setQuery(query);
      debouncedFetchUsers();
    }
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [view, ClinicId, tabValue?.id, debouncedFetchUsers]);


  // Debounced fetch users for department (not timeline)
  const debouncedFetchDepartmentUsers = useMemo(() => {
    return debounce(() => {
      if (ClinicId && tabValue?.id) {
        getUsersByClinic(ClinicId, tabValue.id.toString()).then((userRes) => setUsers(userRes.objects));
      }
    }, 400);
  }, [ClinicId, tabValue?.id]);

  useEffect(() => {
    let limit = '100';
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    }

    if (tabValue?.id && view !== 'timeline') {
      let queryStr = '';
      if (selectedDoctor.length > 0) {
        queryStr = `limit=${limit}&order_by=end_datetime&department__id=${tabValue.id}&user__id__in=${selectedDoctor.join(',')}`;
      } else {
        queryStr = `limit=${limit}&order_by=end_datetime&department__id=${tabValue.id}`;
      }
      setQuery(queryStr);

      debouncedFetchDepartmentUsers();
    }
    return () => {
      debouncedFetchDepartmentUsers.cancel();
    };
  // eslint-disable-next-line
}, [tabValue, ClinicId, selectedDoctor, view, debouncedFetchDepartmentUsers]);

  // Query update for appointments filters

  // Ref for calendar instance to scroll to current time
  const calendarRef = useRef<Eventcalendar>(null);

  // Scroll to current time when switching to day/week/timeline view
  useEffect(() => {
    if ((view === 'day' || view === 'week' || view === 'timeline') && calendarRef.current) {
      const now = new Date();
      // Small delay to ensure the view has rendered
      calendarRef.current?.navigate(now);
    }
  }, [view]);

  useEffect(()=> {
    const myResources: MbscResource[] | undefined = users?.map((user: UserBasic) =>({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
    }));
    if (myResources) {
      const unoqueResources = Array.from(
        new Map(myResources.map((resource) => [resource.id, resource])).values()
      );
      setResource(unoqueResources);
    }
  }, [users]);


  // Handle right-click event
  const handleEventRightClick = (args: MbscEventClickEvent) => {
    if (!args.event.title?.includes('Out of Office')) {
      return;
    }
    args.domEvent.preventDefault();  // Prevent the default context menu
    setClickedEvent(args.event);  // Set the clicked event
    // Set the menu position at the cursor location
    setMenuPosition({
      mouseX: args.domEvent.clientX,
      mouseY: args.domEvent.clientY
    });
  };

  // Close the Material-UI menu
  const closeMenu = () => {
    setMenuPosition(null);
  };

  useEffect(() => {
    if (view === 'timeline') {
      setSelectedDoctor([]);
      setUseTimeline(true);
    } else {
      setUseTimeline(false);
    }
  }, [view]);

  // Handle calendar view change
  const changeView = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let calView = {};
    switch (event.target.value) {
    case 'month':
      calView = { calendar: { labels: true } };
      break;
    case 'week':
      calView = { schedule: { type: 'week', maxEventStack: 1 } };
      break;
    case 'day':
      calView = { schedule: { type: 'day', timeCellStep: 15, maxEventStack: 4 } };
      break;
    case 'timeline':
      calView = {
        timeline: {
          type: 'day',
          timeCellStep: 15,
        }
      };
      break;
    }
    setView(event.target.value);
    setCalView(calView);
  } , []);

  const avatars = useMemo(() => {
    return users?.map((user: UserBasic) => ({
      id: user.id,
      name: `${user.first_name}`,
      src: '',
      selected: selectedDoctor?.includes(user.id)
    }));
  }, [users, selectedDoctor]);

  const renderCustomResource = (resource: MbscResource) => (
    <div className='cal-res-ava'>
      {resource && resource.name && <Avatar
        alt={resource.name}
        src={resource.img}
        sx={{
          width: 50,
          height: 50,
          ...(typeof(resource.id) === 'number' && {bgcolor: numberToColorHash(resource.id)}), // Background color if no image
          fontSize: '0.8rem' // Smaller font for the initials
        }}
      >
        {!resource.img && resource.name[0]} {/* Display first letter if no image */}
      </Avatar>
      }
      <div className="resource-name">{resource.name}</div></div>
  );

  const renderEvent = (ev: MbscCalendarEventData) => {
    const status = (ev as any)?.status as string | undefined;
    if (status === 'CANCELLED') {
      return <div className='cal-event-label cal-event-cancel'>
        {`${ev.title?.split('--')[0]}`}
      </div>;
    }
    return ( <div className='cal-event-label'>
      {ev.title?.split('--')[0]}
    </div>);
  };

  const handleAvatarSelection = useCallback((id: number) => {
    if (id === -1) {
      // Clear all in one shot
      setSelectedDoctor([]);
      return;
    }

    setSelectedDoctor((prev) => {
      if (id < 0) {
        // Ignore other negative ids
        return prev;
      }
      if (prev.includes(id)) {
        // Deselect one
        return prev.filter((userId) => userId !== id);
      }
      // Select one
      return [...prev, id];
    });
  }, []);

  // Custom header with navigation buttons
  const customWithNavButtons = useCallback(
    () => (
      <div className='cal-container'>
        <div className='cal-ftr'>
          {!useTimeline && (tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound' || tabValue?.name === 'Consultation') && avatars && <HorizontalAvatarList avatars={avatars} maxWidth={1000} onClick={handleAvatarSelection}/>}
          {view === 'timeline' && (tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound' || tabValue?.name === 'Consultation') && 
            <IconButton onClick={()=>{
              setView('month');
              setCalView({ calendar: { labels: true } });
              const adminDept = departmentList.find((department: DepartmentDetail) => department.name === 'Admin');
              if (adminDept) {
                setTabValue(adminDept);
              } else if (departmentList.length > 0) {
                setTabValue(departmentList[0]);
              }
            }}
            disableFocusRipple
            disableTouchRipple
            >              
              <Typography variant='caption' color="primary.main" fontSize={'16px'} fontWeight={'600'}><SendBackIcon/>{tCalendar('goBack')}</Typography>
            </IconButton>
          }
        </div>
        <div className='cal-nav'>
          <CalendarNav className="cal-header-nav"/>
          <div className="cal-header-picker">
            <SegmentedGroup value={view} onChange={changeView}>
              <Segmented value="day">{tCalendar('day')}</Segmented>
              <Segmented value="week">{tCalendar('week')}</Segmented>
              <Segmented value="month">{tCalendar('month')}</Segmented>
              {/* {(tabValue?.name === 'Consultation' || tabValue?.name === 'Surgery' || tabValue?.name === 'Ultrasound') && <Segmented value="timeline" className='cal-schedule'>Schedule</Segmented>} */}
            </SegmentedGroup>
          </div>
          <div>
            <CalendarPrev className="cal-header-prev" />
            <CalendarToday className="cal-header-today" />
            <CalendarNext className="cal-header-next" />
          </div>
          <div>
            <Button variant='text' onClick={() => {setShowOutofOfficeForm(true);}}><WorkOffIcon sx={{'color': '#E17E61'}}/></Button>
          </div>
        </div>
      </div>
    ),
    [changeView, view, avatars, useTimeline, tabValue, handleAvatarSelection, departmentList, tCalendar],
  );



  const numberToColorHash = useCallback((num: number) => {
    // Seeded random generator for consistent colors per ID
    const seededRandom = (seed: number) => {
      const x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    };
    
    // Generate bright RGB values (128-255 range for brightness)
    const r = Math.floor(seededRandom(num * 1.1) * 128) + 128;
    const g = Math.floor(seededRandom(num * 2.3) * 128) + 128;
    const b = Math.floor(seededRandom(num * 3.7) * 128) + 128;
    
    // Convert to hex
    const toHex = (n: number) => {
      const hex = n.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }, []);



  function hslToHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = l - c / 2;
    let r = 0, g = 0, b = 0;

    if (0 <= h && h < 60) {
      r = c; g = x; b = 0;
    } else if (60 <= h && h < 120) {
      r = x; g = c; b = 0;
    } else if (120 <= h && h < 180) {
      r = 0; g = c; b = x;
    } else if (180 <= h && h < 240) {
      r = 0; g = x; b = c;
    } else if (240 <= h && h < 300) {
      r = x; g = 0; b = c;
    } else if (300 <= h && h < 360) {
      r = c; g = 0; b = x;
    }

    // Convert r, g, b from 0–1 to 0–255 and then to hex
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    const redHex = r.toString(16).padStart(2, '0');
    const greenHex = g.toString(16).padStart(2, '0');
    const blueHex = b.toString(16).padStart(2, '0');

    return `#${redHex}${greenHex}${blueHex}`;
  }

  // Wrap updateStatus in useMemo for stable reference
  const updateStatus = useMemo(() =>
    debounce(() => {
      let dateFrom: Date;
      let dateTo: Date;

      if (view === 'day' && viewDateTo) {
        dateFrom = new Date(viewDateTo.toDateString());
        dateTo = new Date(viewDateTo.toDateString());
      } else if (viewDateFrom && viewDateTo) {
        dateFrom = new Date(viewDateFrom.toDateString());
        dateTo = new Date(viewDateTo.toDateString());
      } else {
        // fallback to current month if dates are not set
        const now = new Date();
        dateFrom = new Date(now.getFullYear(), now.getMonth(), 1);
        dateTo = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      }

      const formattedDateFrom = dateFrom.toISOString().split('T')[0];
      const formattedDateTo = dateTo.toISOString().split('T')[0];

      getStatus(
        formattedDateFrom,
        formattedDateTo,
        tabValue?.id?.toString(),
        selectedDoctor?.toString()
      ).then((data: Status[]) => setStatus(data));
    }, 300)
  , [view, viewDateFrom, viewDateTo, tabValue, selectedDoctor]);
  // selectedDate removed from deps to prevent excessive calls

  useEffect(() => {
    updateStatus();
  }, [appointments, updateStatus]);

  useEffect(() => {
    updateStatus();
  }, [selectedDate, updateStatus]);


  // Fetch calendar events from API 
  useEffect(() => {
    if (query && tabValue) {
      showLoader();
      setAppointments({} as Appointment[]);
      let debugQuery = query;
      if (tabValue?.id) {
        const params = new URLSearchParams(query);
        params.set('department__id', String(tabValue.id));
        debugQuery = params.toString();
      }
      getAppointments(debugQuery, viewDateFrom, viewDateTo, ClinicId).then((appointments) => {
        setAppointments(appointments?.objects);
        const events = (appointments?.objects ?? [])
          .map((appointment: Appointment) => {
            // Localize status label for title while keeping names as-is
            const rawStatus = appointment?.status ?? '';
            const statusKey = rawStatus.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
            const localizedStatus = tCalendar(statusKey, { defaultValue: rawStatus.replace(/_/g, '-') });
            // Build a localized title only for the status part after `--`; keep names as-is
            const baseTitle = getEventText(appointment ?? {});
            const titlePrefix = baseTitle.split('--')[0];
            const finalTitle = view === 'timeline' ? (appointment?.department__name ?? '') : `${titlePrefix}--${localizedStatus}`;

            const msbcEvent: CustomMbscEvent = {
              start: convertToLocalDateTime(appointment?.start_datetime ?? ''),
              end: convertToLocalDateTime(appointment?.end_datetime ?? ''),
              title: finalTitle,
              id: appointment?.id ?? `${Math.random()}`,
              color: view === 'timeline'
                ? numberToColorHash(appointment?.department__id ?? 0)
                : getEventBgColor(appointment?.status ?? ''),
              resource: appointment?.user?.id ?? '',
              status: rawStatus,
            };
            return msbcEvent;
          });
        setEvents(events);
      }).catch((error)=> {
        console.log(error);
        addAlert(tCalendar('errorWhileUpdatingCalendar'), 'error');
        hideLoader();
      }).finally(() => hideLoader());
    }
  
  }, [showLoader, hideLoader, addAlert, numberToColorHash, query, modelStateUpdate, viewDateFrom, viewDateTo, ClinicId, tCalendar, view, tabValue]);


  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
  };


  function handleEnventDragEnd(args: MbscEventDragEvent, inst: EventcalendarBase): void {
    showLoader();
    const start = args.event.start as Date;
    const end = args.event.end as Date;
    const id = args.event.id;
    if (id) {
      updateAppointmentDate(id as number, start, end).then((res: any) => {
        addAlert(tCalendar('scheduleUpdated'), 'success');
      }).catch((error: any) => {
        addAlert(error.response?.data?.errors?.[0]?.detail || tCalendar('errorOccurred'), 'error');
        console.log(error);
        hideLoader();
      })
        .finally(() => {
          hideLoader();
          setModelStateUpdate(!modelStateUpdate);
        });
    }
  }

  function getFirstAndLastDayOfCurrentMonth(): { firstDay: string; lastDay: string } {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-indexed: Jan is 0
  
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0); // Day 0 of next month = last day of current
  
    const format = (date: Date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
        date.getDate()
      ).padStart(2, '0')}`;
  
    return {
      firstDay: format(firstDay),
      lastDay: format(lastDay),
    };
  }


  useEffect(() => {
    if(initialLoad){
      setInitialLoad(false);
      // If selectedDate is null, use the first and last day of the current month 
      getStatus(
        getFirstAndLastDayOfCurrentMonth().firstDay,
        getFirstAndLastDayOfCurrentMonth().lastDay,
        tabValue?.id?.toString() ?? '2',
        selectedDoctor?.toString()
      )
        .then((data: Status[]) => setStatus(data))
        .catch((error: any) => {
          console.error('Error fetching initial status:', error);
          addAlert('Failed to fetch initial status', 'error');
        }).finally(() => hideLoader());
    }
    // eslint-disable-next-line 
  },[]);

  function handleDateChange(args: MbscSelectedDateChangeEvent, inst: EventcalendarBase): void {
    const date = formatDateToLocalYYYYMMDD(args.date as Date);
    setSelectedDate(date);
  }

  // Filter the Tabs for the department List to be passed to the appointment modal.
  // Define the expected order for departments (matching tab order)
  const departmentOrder = ['Pathology', 'Semen Collection', 'Admin', 'Consultation', 'Ultrasound', 'Surgery'];
  const getDepartmentTabs = () => {
    const filteredDepts = departmentList.filter((department: DepartmentDetail) => departmentFilters.includes(department.name) || docFilters.includes(department.name));
    return filteredDepts.sort((a, b) => {
      const indexA = departmentOrder.indexOf(a.name);
      const indexB = departmentOrder.indexOf(b.name);
      // If department is not in the order array, put it at the end
      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });
  };
  
  function handleEventInit(): void {
    showLoader();
  }

  function handleEventUpdate(): void {
    hideLoader();
  }

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,      
      boxShadow: theme.shadows[1],      
    },
  }));

  const getTooltipData = (tooltipText: string) => {
    return (
      <Box bgcolor={'white'} p={1}>
        <Typography variant='body2' color="textSecondary" fontWeight={600}> 
          {tooltipText}
        </Typography>
      </Box>
    );
  };

  useEffect(() => {
    let limit = '100';    
    if (view === 'month') {
      limit = '1000';
    } else if (view === 'week') {
      limit = '500';
    } else {
      limit = '100';
    }
    if (filterAppointments !== undefined && tabValue?.id) {
      setQuery(`limit=${limit}&order_by=end_datetime&department__id=${tabValue?.id}&status=${filterAppointments}`);
    }
  }, [filterAppointments, tabValue?.id, view]);

  // Debounced OOO appointments fetch
  const fetchOooEvents = useMemo(() => {
    return debounce(() => {
      if(ClinicId && tabValue && viewDateFrom && viewDateTo){
        getAppointmentsOOO({
          clinic_id: ClinicId,
          appointment_date_after: viewDateFrom ? formatDateToDDMMYYYY(viewDateFrom) : undefined,
          appointment_date_before: viewDateTo ? formatDateToDDMMYYYY(viewDateTo) : undefined
        }).then((appointments) => {
          const oooEvents = (appointments?.objects ?? []).filter((appointments: Appointment) => appointments.status !== 'CANCELLED')
            .map((appointment: Appointment) => {
              const msbcEvent: CustomMbscEvent = {
                start: convertToLocalDateTime(appointment.start_datetime),
                end: convertToLocalDateTime(appointment.end_datetime),
                // Localize the "Unavailable" tag in the title
                title: `${appointment.user.first_name} ${appointment.user.last_name} - ${tCalendar('unavailable', { defaultValue: 'Unavailable' })}`,
                order: 1,
                id: appointment.id,
                color: '#47494a',
                resource: appointment.user.id,
                status: appointment.status,
                text: appointment.remark,
                tooltip: appointment.remark,
                dragBetweenResources: false,
                dragBetweenSlots: false,
                dragInTime: false,
                cssClass: 'cal-ooo-events',
                overlap: true,
                category: 'OUT_OF_OFFICE',
              };
              return msbcEvent;
            });
          setOooEvents(oooEvents);
        });
      }
    }, 400);
  }, [ClinicId, tabValue, viewDateFrom, viewDateTo, tCalendar]);

  useEffect(() => {    
    fetchOooEvents();
    return () => {
      fetchOooEvents.cancel();
    };
  }, [fetchOooEvents, modelStateUpdate]);

  const getFilteredDepartments = () => {
    return departmentList.filter((department: DepartmentDetail) => {
      const isEnabled = isDepartmentFeatureEnabled(department.name);
 
      // Only include departments that are in the filters and have featureEnabled as true
      return departmentFilters.includes(department.name) && isEnabled;
    });
  };

  
  const getFilteredDepartments2 = () => {
    return departmentList.filter((department: DepartmentDetail) => {
      const isEnabled = isDepartmentFeatureEnabled(department.name);  
      // Only include departments that are in the filters and have featureEnabled as true
      return docFilters.includes(department.name) && isEnabled;
    });
  };

  // Ensure loader is cleared whenever switching between CALENDAR and TABLE views
  useEffect(() => {
    hideLoader();
  }, [currentView, hideLoader]);

  return (
    <>
      {showOutofOfficeForm && <OutOfOfficeForm open={showOutofOfficeForm} handleClose={handleClosehowOutofOfficeFormModel}/>}
      <CustomModal
        isOpen={openViewModel}
        onClose={handleCloseViewModel}
        id={viewEvent?.event.id as number}
      />
      <AppointmentModal open={openCreateModel} onClose={handleCloseCreateModel} resource={createEvent?.event.resource?.toString()} slotDate={createEvent?.event?.start as Date || undefined} slotDepartment={tabValue?.id} departmentName={tabValue?.name || 'Admin'} departmentTabs={getDepartmentTabs()} handleTabChange={setTabValue} view={view} />
      <div className={'cal-tabs-sec'}>
        <div className='cal-deps'>
          {view !== 'timeline' &&
            <><ButtonGroup sx={{
              borderRadius: '2rem',
              height: 'fit-content',
              display: 'flex',
              gap: '5px', // Add gap between buttons
              '& .MuiButton-root': {
                border: 'none',
              },
              '& .MuiButton-root:hover': {
                backgroundColor: 'transparent', // Ensure hover doesn't add background color
              },
            }} variant="outlined" color='secondary' aria-label="Basic button group">
              {getFilteredDepartments().map((department: DepartmentDetail) => (<Button sx={{
                color: tabValue?.id === department.id ? '#E17E61' : 'inherit',
                fontFamily: 'nunito',
                fontWeight: tabValue?.id === department.id ? 900 : 500,
                fontSize: '1rem',
                border: '1px solid black',
                height: '2rem'
              }} key={department.id} onClick={() => { setTabValue(department); } }>{getDepartmentDisplayName(department.name_label ?? department.name)}</Button>))}
            </ButtonGroup><Divider orientation="vertical" flexItem /></>
          }
          {view !== 'timeline' && <ButtonGroup sx={{
            borderRadius: '2rem',
            height: 'fit-content',
            display: 'flex',
            gap: '5px', // Add gap between buttons
            '& .MuiButton-root': {
              border: 'none',
            },
            '& .MuiButton-root:hover': {
              backgroundColor: 'transparent', // Ensure hover doesn't add background color
            },
          }} variant="outlined" color='secondary' aria-label="Basic button group">
            {departmentList &&
              getFilteredDepartments2().map((department: DepartmentDetail) => (
                <Button
                  sx={{
                    color: tabValue?.id === department.id ? '#E17E61' : 'inherit',
                    fontFamily: 'nunito',
                    fontWeight: tabValue?.id === department.id ? 900 : 500,
                    fontSize: '1rem',
                    border: '1px solid black',
                    height: '2rem',                    
                  }}
                  key={department.id}
                  onClick={() => {
                    setTabValue(department);
                  }}
                >
                  {getDepartmentDisplayName(department.name_label ?? department.name)}
                </Button>
              ))}
          </ButtonGroup>}
        </div>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center',  }}>
          <LightTooltip placement={'left-end'} title={currentView ==='CALENDAR' ? null : getTooltipData(tCalendar('calendarView'))}>
            <Typography component={'span'}>
              <IconButton disabled={currentView==='CALENDAR'} onClick={()=>{
                setCurrentView('CALENDAR');
              }}>
                <CalendarViewMonthIcon/>
              </IconButton>
            </Typography>
          </LightTooltip>
          <LightTooltip placement={'left-end'} title={currentView ==='TABLE' ? null : getTooltipData(tCalendar('timelineView'))}>
            <Typography component={'span'}>
              <IconButton disabled={currentView==='TABLE'} onClick={()=>{
                setCurrentView('TABLE');
              }}>
                <ListIcon/>
              </IconButton>
            </Typography>
          </LightTooltip>
        </Stack>
      </div>
      {currentView === 'CALENDAR' ? <div onClick={closeMenu} onContextMenu={handleContextMenu} className='table-parent'>
        <Suspense fallback={<CalendarComponent/>}>
          <Eventcalendar
            ref={calendarRef}
            locale={mobiscrollLocale}
            onPageLoaded={handlePageLoad}
            onPageChange={handlePageLoad}
            onEventUpdate={handleEventUpdate}
            onInit={handleEventInit}
            onSelectedDateChange={handleDateChange}
            renderScheduleEventContent={renderEvent}
            renderLabelContent={renderEvent}
            clickToCreate={true}
            dragToCreate={false}
            dragToMove={false}
            dragToResize={false}
            eventDelete={true}
            renderHeader={customWithNavButtons}
            height={'80vh'}
            width={'100%'}
            view={calView}
            onCellDoubleClick={(event: MbscCellClickEvent) => {
              event.domEvent.preventDefault();
              event.domEvent.stopPropagation();
            }}
            {...(useTimeline ? { data: filterAppointmentsScheduled==='Unavailable' ? [...oooEvents] : filterAppointmentsScheduled ? [...myEvents.filter((event: MbscCalendarEvent) => event?.title?.includes(filterAppointmentsScheduled))]:
              [...myEvents, ...oooEvents] } : { data: myEvents })}
            cssClass="md-switching-view-cont"
            onEventRightClick={handleEventRightClick}
            onEventDragEnd={handleEnventDragEnd}
            {...(useTimeline && { resources: resource })}
            {...(useTimeline && { renderResource: renderCustomResource })}
            onEventCreate={(event: MbscEventCreateEvent) => {
              setCreateEvent(event);
              handleOpenCreateModel(event);
            } }
            onEventClick={(event: MbscEventClickEvent) => {
              if (event.event.title?.includes('Out of Office') || event.event.category === 'OUT_OF_OFFICE') {
                return;
              }

              setViewEvent(event);
              handleOpenViewModel();
            } }
                        
            // Calendar date disabling logic:
            // If either canAdd or canEdit is false, disable all dates (no booking or editing allowed).
            // If both are true, only disable past dates (normal booking behavior).

            invalid={
              // If either permission is false, disable all dates (no booking or editing allowed)
              (!canAdd || !canEdit)
                ? [{ start: new Date(0), end: new Date(2050, 11, 31) }] // All dates disabled
                // If both permissions are true, only disable past dates (normal booking behavior)
                : [{ start: new Date(0), end: new Date(new Date().setDate(new Date().getDate())) }] // Only past dates disabled
            }
          />
          {view !== 'timeline' ? 
            <div className='calFooter'>
              <Stack direction="row" spacing={1}>
                {status && status.map((st: Status, index: number) => {
                  // Convert status to camelCase for translation key, then uppercase for display
                  const statusKey = st?.status.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
                  let statusLabel = tCalendar(statusKey);
                  // If translation returns the same as key, fallback to formatted status
                  if (!statusLabel || statusLabel === statusKey) {
                    statusLabel = st?.status.replace(/_/g, '-');
                  }
                  const displayLabel = statusLabel.replace(/ /g, '-').toUpperCase();
                  return (
                    <Chip 
                      key={st?.status}
                      label={`${displayLabel}: ${st?.count}`}
                      variant={filterAppointments === st?.status ? 'filled' : 'outlined'} 
                      onClick={() => {setFilterAppointments(st?.status);}}
                      sx={{opacity: filterAppointments === st?.status ? 1 : 0.8, backgroundColor: getStatusColor(st.status), border: filterAppointments === st?.status ? `1px solid ${getEventBgColor(st?.status)}` : 'none', color: getEventBgColor(st?.status)}}
                    />
                  );
                })}
              </Stack>
              {filterAppointments && <Button onClick={()=>{setFilterAppointments('');}}>{tGeneral('reset')}</Button>}
            </div> :
            <div className='calFooter'>
              {scheduleFilters.map((filter: string) => {
                // Normalize translation key to lowercase and provide a readable default
                const key = filter.toLowerCase();
                const label = tCalendar(key, { defaultValue: toTitleCase(key) });
                const isActive = filter === filterAppointmentsScheduled?.toLocaleUpperCase();
                return (
                  <Chip
                    key={filter}
                    label={label}
                    variant={isActive ? 'filled' : 'outlined'}
                    onClick={() => { setFilterAppointmentsScheduled(toTitleCase(filter)); }}
                    style={{
                      fillOpacity: 1,
                      opacity: isActive ? 1 : 0.6,
                      backgroundColor: getDepartmentColor(filter),
                      border: isActive ? `1px solid ${getEventBgColor(filter)}` : 'none',
                      color: '#fff',
                      fontWeight: 600,
                    }}
                  />
                );
              })}
            
              {filterAppointmentsScheduled && <Button onClick={()=>{setFilterAppointmentsScheduled('');}}>{tGeneral('reset')}</Button>}
            </div>}
        </Suspense>

        {/* Material-UI Dropdown Menu */}
        <Menu
          open={Boolean(menuPosition)}
          onClose={closeMenu}
          anchorReference="anchorPosition" // Use anchorPosition to position based on mouse click
          anchorPosition={menuPosition ? { top: menuPosition.mouseY, left: menuPosition.mouseX } : undefined} // Menu opens at the cursor
        >
          <MenuItem onClick={() => {
            if (clickedEvent?.id) {
              showLoader();
              cancelAppointmentOOO(clickedEvent?.id as number)
                .catch(() => addAlert(tCalendar('failedToCancelEvent'), 'error'))
                .finally(() => {
                  setModelStateUpdate(!modelStateUpdate);
                  hideLoader();
                });
            }
            closeMenu();
          } }>{tCalendar('cancelEvent')}</MenuItem>
          <MenuItem onClick={() => {
            closeMenu();
          } }>{tGeneral('close')}</MenuItem>
        </Menu>
      </div>:   <AppointmentTable departmentID={tabValue?.id} departmentName={tabValue?.name || 'Admin'} departmentTabs={getDepartmentTabs()} handleTabChange={setTabValue}/>}      
    </>
  );
};
export default CalendarComponent;

function getEventText(appointment: Appointment): string {
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'ADMIN') {
    return `Pt-${appointment.patient?.first_name} Ad-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
  }
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'PATHOLOGY') {
    return `Pt-${appointment.patient?.first_name} Pb-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
  }
  if (appointment.department__name && appointment.department__name.toUpperCase() === 'SEMEN COLLECTION') {
    return `Pt-${appointment.patient?.first_name}--${appointment?.status}`;
  }
  return `Pt-${appointment.patient?.first_name} Dr-${appointment?.user?.first_name ?? ''}--${appointment?.status}`;
}
